import { endpoints } from '../api/endpoints';
import { queryKeys } from './queryKeys';
import { queryConfig } from './queryConfig';
import { createListQueryHook } from './queryFactory';

export const useProducts = createListQueryHook({
  queryKey: queryKeys.products(),
  endpoint: endpoints.products,
  config: {
    staleTime: queryConfig.staleTime.short,
  },
});

